import { render, staticRenderFns } from "./LinkedAccountsWidget.vue?vue&type=template&id=b8b302fa&scoped=true"
import script from "./LinkedAccountsWidget.vue?vue&type=script&lang=ts"
export * from "./LinkedAccountsWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b302fa",
  null
  
)

export default component.exports